import { createContext, useContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';

export type AppRole = 'trainer' | 'client' | 'unknown';

export interface AuthContextValue {
  session: Session | null;
  user: User | null;
  role: AppRole;
  loading: boolean;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    // Sensible defaults when AuthProvider isn't mounted (e.g. in tests).
    return {
      session: null,
      user: null,
      role: 'unknown',
      loading: false,
      signOut: async () => undefined,
    };
  }
  return ctx;
}
